var _defs, _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHappy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 59,
    viewBox: "0 0 60 59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Background",
    x: 0,
    y: 0,
    width: 60,
    height: 59,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 6,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_55907",
    "data-name": "Group 55907",
    transform: "translate(9.244 3.153)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9.24, -3.15)",
    filter: "url(#Background)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Background-2",
    "data-name": "Background",
    cx: 21,
    cy: 20.5,
    rx: 21,
    ry: 20.5,
    transform: "translate(9 3)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Face",
    transform: "translate(9.752 12.903)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mouth",
    d: "M50.47,107.642a11.756,11.756,0,0,1-11.113-7.917,1.394,1.394,0,1,1,2.633-.912,8.966,8.966,0,0,0,16.96,0,1.394,1.394,0,1,1,2.632.913,11.756,11.756,0,0,1-11.112,7.916Z",
    transform: "translate(-39.263 -87.801)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_40",
    "data-name": "Ellipse 40",
    cx: 2.672,
    cy: 2.672,
    r: 2.672,
    transform: "translate(15.273)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_41",
    "data-name": "Ellipse 41",
    cx: 2.672,
    cy: 2.672,
    r: 2.672,
    transform: "translate(1.797)",
    fill: "#444"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappy);
export default __webpack_public_path__ + "static/media/happy.68811ec871d7f07f96e48d8263b90964.svg";
export { ForwardRef as ReactComponent };